import { render, staticRenderFns } from "./linkables.vue?vue&type=template&id=4d5de318&scoped=true&lang=pug&"
import script from "./linkables.vue?vue&type=script&lang=js&"
export * from "./linkables.vue?vue&type=script&lang=js&"
import style0 from "./linkables.vue?vue&type=style&index=0&id=4d5de318&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5de318",
  null
  
)

export default component.exports